/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-expressive-link.html";

import "@nuskin/ns-style-elements";

/**
 * <p>The ns-expressive-link is a stylized link with a small underline animation</p>
 *
 * <h2>UX/Design Docs</h2>
 * <p>Need to find</p>
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-expressive-link>Click Me Please</ns-expressive-link>
 *     <br>
 *     <ns-expressive-link id="customLink"></ns-expressive-link>
 *   </template>
 * </demo-snippet>
 *
 * <marked-element>
 *  <div slot="markdown-html">
 *  <script type="text/markdown">
 *
 *      ### Styling
 *
 *      ##### `<ns-expressive-link>` provides the following custom properties and mixins for styling:
 *
 *      Custom property                 | Description                                           | Default
 *      --------------------------------|-------------------------------------------------------|-------------------
 *      `--ns-expressive-link`          | Mixin applied to the link itself                      | `{}`
 *      `--ns-expressive-link-before`   | Mixin applied to the highlight before it is hovered   | `{}`
 *      `--ns-expressive-link-after`    | Mixin applied to the highlight after it is hovered    | `{}`
 *
 *      ### Slots
 *
 *      ##### `<ns-expressive-link>` provides the following slots for content:
 *
 *      Custom property                 | Description                           | Default
 *      --------------------------------|---------------------------------------|-------------------
 *      `default`                       | Content of the link                       | `'Sample Link'`
 *
 *  </script>
 * </marked-element>
 *
 */
export class NsExpressiveLink extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();

    this.$.nsExpressiveLink.addEventListener(
      "touchend",
      this._switchWebPageForMobile
    );
  }

  static get is() {
    return "ns-expressive-link";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * The highlight color after the link is hovered.
       * Can be a named color, a hex value, a RGB value or even a css variable
       */
      afterColor: {
        type: String,
        observer: "_after"
      },
      /**
       * The highlight color before the link is hovered
       * Can be a named color, a hex value, a RGB value or even a css variable
       */
      beforeColor: {
        type: String,
        observer: "_before"
      },
      /**
       * Where the link takes the user when clicked
       */
      href: {
        type: String,
        value: "https://www.nuskin.com"
      },
      /**
       * The state of the highlight animation: animate-in or animate-out.
       * Changing these values will also trigger the animation.
       */
      state: {
        type: String,
        value: ""
      },
      /**
       * The target of the <a> tag
       */
      target: {
        type: String,
        value: "_self"
      }
    };
  }

  _switchWebPageForMobile() {
    window.location = this.href;
  }

  /**
   * Triggered by an observer on afterColor that sets the new color on the custom css variable
   */
  _after() {
    this.updateStyles({ "--expressive-link-bg-2": this.afterColor });
  }

  /**
   * Triggered by an observer on beforeColor that sets the new color on the custom css variable
   */
  _before() {
    this.updateStyles({ "--expressive-link-bg-1": this.beforeColor });
  }

  /**
   * Animates the highlight in
   */
  _animateIn(e) {
    this.state = "animate-in";
  }

  /**
   * Animates the highlight out
   */
  _animateOut() {
    this.state = "animate-out";
  }
}
customElements.define(NsExpressiveLink.is, NsExpressiveLink);
